jQuery(($) => {
  class Slider {
    constructor(element, args = {}) {
      this._ = element;
      this._element = $(element);
      this._list = this._element.find('.o-random-single-slide__list');
      this._button = this._element.find('.o-random-single-slide__random-button');
      this._slidesCount = this._list.find('.o-random-single-slide__item').length;
      
      const initialSlide = Math.floor(Math.random() * this._slidesCount);
      this._seenSlides = [initialSlide];

      this._args = $.extend(
        {
          slidesToShow: 1,
          arrows: false,
          variableWidth: false,
          centerMode: true,
          centerPadding: '0px',
          initialSlide: initialSlide,
          swipe: false
        },
        args
      );

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this.setupSlick();
      this._element.trigger('init', this);
      this._element.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        if (nextSlide === 0 && currentSlide === slick.slideCount - 1) {
          this._element.addClass('o-random-single-slide--resetting');

          setTimeout(() => {
            this._element.removeClass('o-random-single-slide--resetting');
          }, 500);
        }
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Button Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleButtonClick= () => {
      const randomSlide = Math.floor(Math.random() * this._slidesCount);

      if (this._seenSlides.length === this._slidesCount) {
        this._seenSlides = [];
      }

      if (this._seenSlides.includes(randomSlide)) {
        this.handleButtonClick();
      } else {
        this._seenSlides.push(randomSlide);
        this._list.slick('slickGoTo', randomSlide, true);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._button.on('click', this.handleButtonClick);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Slick
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupSlick = () => {
      this._list.slick(this._args);
      this._element.trigger('setup-slick', this);
    };
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.slider = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slider = new Slider(_[i], opt);
      else ret = _[i].slider[opt].apply(_[i].slider, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-random-single-slide').slider();
});
